export class Timezone {

    id: number;

    name: string;

    tz: string;

    static createFromObject(object: any): Timezone {
        let timezone = new Timezone();
        if (object.id !== undefined)
            timezone.id = object.id;
        if (object.name !== undefined)
            timezone.name = object.name;
        if (object.tz !== undefined)
            timezone.tz = object.tz;
        return timezone;
    }

}



// WEBPACK FOOTER //
// ./src/entities/timezone.ts